// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconFileBookmark = createRemixIcon('IconFileBookmark', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.251 0h-1.25v24h20V5.732l-.366-.366l-5-5L16.269 0zm1.25 21.5v-19h2V12l3.5-3.5l3.5 3.5V2.5h1.732l4.268 4.268V21.5z\" clip-rule=\"evenodd\"/>");
